import { Box, Typography } from '@mui/material';
import { NoPatientFoundPlaceholder } from 'components/NoPatientFoundPlaceholder';

export const PatientSearchBarNoOptionsPlaceholder = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography
        variant='body2'
        sx={{
          paddingY: 1,
          borderBottom: theme => `1px solid ${theme.palette.grey[300]}`,
          marginBottom: 1,
          color: 'text.secondary',
        }}
      >
        No match found
      </Typography>

      <Typography variant='body2' sx={{ color: 'text.secondary' }}>
        Please follow these steps to find the patient:
      </Typography>

      <NoPatientFoundPlaceholder />

      <Typography
        variant='body2'
        sx={{ color: 'text.secondary', fontWeight: 600 }}
      >
        Note: Synchronization occurs every hour at :15.
      </Typography>
    </Box>
  );
};
